// src/services/DonService.js
import { base_url } from "../utils/constante";

const json = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      data?.message ||
      (data?.errors && Object.values(data.errors)[0]?.[0]) ||
      "Une erreur est survenue";
    throw new Error(msg);
  }
  return data;
};

/** Crée la session Stripe et renvoie { url } */
export const creerDon = async ({ montant, nom, email, message }) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${base_url}dons/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ montant, nom, email, message }),
  });
  return json(res);
};

/** Détail du don pour la page merci */
export const getDonSession = async (sessionId) => {
  const res = await fetch(`${base_url}dons/session/${sessionId}`, {
    headers: { Accept: "application/json" },
  });
  return json(res);
};

/** Même calcul que le backend (3,25 % + 0,25 €), en centimes */
export const estimerNet = (euros) => {
  const montant = Math.round((parseFloat(String(euros).replace(",", ".")) || 0) * 100);
  const frais = Math.ceil(montant * 0.0325 + 25);
  return { montant, frais, net: Math.max(0, montant - frais) };
};

export const euros = (centimes) =>
  (centimes / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });